export const sidePadding = "36";
